import {StyleteqState} from "../_definitions/styleteq";

export const loadingTabSelector = (state: StyleteqState) => state.user.loadingTab;
export const loadingUserSelector = (state: StyleteqState) => state.user.loadingUser;
export const stateListSelector = (state: StyleteqState) => state.user.stateList;
export const cityListSelector = (state: StyleteqState) => state.user.cityList;
export const saveSelector = (state: StyleteqState) => state.user.isSaving;
export const styleLoadSelector = (state: StyleteqState) => state.user.styleLoad;
export const likedStyleLoadSelector = (state: StyleteqState) => state.user.likedStyleLoad;
export const userIDSelector = (state: StyleteqState) => state.user.userID;
export const followModalTabSelector = (state: StyleteqState) => state.user.followModalTab;
export const currentUserIdSelector = (state: StyleteqState) => state.user.currentUserID;
export const currentUserSelector = (state: StyleteqState) => state.data.users.get(state.user.currentUserID);

export const getUsersSelector = (state: StyleteqState) => state.user.users;
export const getShopsSelector = (state: StyleteqState) => state.user.shops;
export const getStylesSelector = (state: StyleteqState) => state.user.styles;
export const getSpecialsSelector = (state: StyleteqState) => state.user.specials;



// WEBPACK FOOTER //
// ./app/client/user/selectors.ts